import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';

export const selectRegistrationData = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState.registrationData,
);
